import React from "react";

export interface ApplyForMortgageWidgetProps {
  onApply: () => void;
}

const ApplyForMortgageWidget: React.FC<ApplyForMortgageWidgetProps> = ({
  onApply,
}) => {
  return (
    <div className="widget">
      <button
        className="btn theme-btn-1"
        onClick={() => {
          onApply();
        }}
      >
        Apply for Mortgage
      </button>
    </div>
  );
};

export default ApplyForMortgageWidget;
